import { configureStore } from "@reduxjs/toolkit";
import { rootReducers } from "./reducers";
import { SSE } from "./modules/sse/sse-module";

export const store = configureStore({
  reducer: rootReducers,
  devTools: process.env.NODE_ENV !== "production",
});

export type AppStore = typeof store;
export type AppState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type ActionStoreParams = { state: AppState; dispatch: AppDispatch };

// sseModule не должно быть здесь!
// TODO подумать как вынести это и чтобы оно инициализировалось после инициализации стора
export const sseModule = new SSE();
